import { NgModule } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@NgModule({
  imports: [MatIconModule],
})
export class IconsModule {
  private pathIcons: string = './assets/img/icons';

  constructor(
    private domSanitizer: DomSanitizer,
    public matIconRegistry: MatIconRegistry,
  ) {
    this.registerIconsNamespace();
  }

  private setPath(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  private registerIconsNamespace() {
    const namespace = 'icons';
    this.matIconRegistry
      .addSvgIconInNamespace(
        namespace,
        'green-check',
        this.setPath(`${this.pathIcons}/green-check.svg`),
      )
      .addSvgIconInNamespace(
        namespace,
        'red-cross',
        this.setPath(`${this.pathIcons}/red-cross.svg`),
      );
  }
}
